// import React, { useEffect } from 'react'
// import { useSymbolPrices } from '../../../context/WebSocketContext';
import { OneClickTrading } from '../../../api/request/dashboard/dashboard';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setAmountForSymbol } from '../../../store/Slices/amountSlice';
// import { amountMap } from '../../../MobileView/pages/Quotes';

const BidBuy = ({ symbolId, digits }) => {
    const dispatch = useDispatch()
    const { accountId } = useSelector(state => state.accountSummary)
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])
    const symbolParameterData = useSelector((state) => state?.symbol?.allSymbolParams?.[symbolId], shallowEqual);
    const amount = useSelector((state) =>
        state?.amount?.[symbolId] ?? symbolParameterData?.minimumAmountPerDeal ?? 0.01
    )
    const { t } = useTranslation()
    const buyPosition = async () => {
        const minAmount = symbolParameterData?.minimumAmountPerDeal ?? 1;
        const maxAmount = symbolParameterData?.maximumAmountPerDeal ?? 100;
        const ratio = amount / minAmount;
        const isMultiple = Math.abs(ratio - Math.round(ratio)) < 1e-8;
        if (amount < minAmount || amount > maxAmount) {
            toast.error(`Invalid Amount`);
            setTimeout(() => {
                dispatch(setAmountForSymbol({ symbolId, amount: minAmount }));
            }, 1000);

            return;
        }
        if (!isMultiple) {
            toast.error(`Amount must be a multiple of ${minAmount}`);
            setTimeout(() => {
                dispatch(setAmountForSymbol({ symbolId, amount: minAmount }));
            }, 1000);

            return;
        }

        try {
            const payload = {
                accountId: Number(accountId),
                side: -1,
                amount,
                symbolId,
                comment: "One-click trading",
            };
            const { data } = await OneClickTrading(payload);
            // if (data?.id) {
            //     const tradeId = data.id;
            //     const symbolName = symbol?.name;
            //     const price = data.side === 1 ? symbol?.ask : symbol?.bid;
            //     const tradeSide = data.side === 1 ? "BUY" : "SELL";

            //     toast.success(`Trade Opened: ID #${tradeId}, ${symbolName} at ${price ? price.toFixed(symbol?.digits) : "0.00"}, ${tradeSide}, Amount: ${data.amount}`);
            // }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Trade execution error");
        }
    }
    return (
        <div className={`border ${symbol?.bidColor == "up" ? "border-green" : symbol?.bidColor == "down" && "border-red"} flex`} onClick={(e) => { e.stopPropagation(); }} onDoubleClick={(e) => { e.stopPropagation(); }}>
            <span className={`${symbol?.bidColor == "up" ? "bgGreen" : symbol?.bidColor == "down" && "bgRed"} bgbuySell text-white px-2 flex justify-center items-center cursor-pointer `} onClick={buyPosition}>{t("sell")}</span>
            <span className={`text-center px-2 flex items-center justify-center ${symbol?.bidColor == "up" ? "green" : symbol?.bidColor == "down" && "red"}`}>{symbol?.bid ? (symbol?.bid).toFixed(digits) : '0.00'}</span>
        </div>
    )
}

export default BidBuy